
import haywardScenario from 'components/support/maps/scenarios/hayward.json';
import calverasScenario from 'components/support/maps/scenarios/calveras.json';
import sanAndreasScenario from 'components/support/maps/scenarios/sanAndreas.json';

const scenarios = {
  calveras: {
    pga: 'pga0p10',
    scenario: calverasScenario,
    description: 'Calaveras M7.0 (mean 0.1g)',
  },
  hayward: {
    pga: 'pga0p25',
    scenario: haywardScenario,
    description: 'Hayward M7.0 (mean 0.2g)',
  },
  sanAndreasP40: {
    pga: 'pga0p40',
    scenario: sanAndreasScenario,
    description: 'San Andreas M8.0 (mean 0.4g)',
  },
  sanAndreasP75: {
    pga: 'pga0p75',
    scenario: sanAndreasScenario,
    description: 'San Andreas M8.0 (high 0.75g)',
  },
};

export default scenarios;



// WEBPACK FOOTER //
// ./js/components/support/maps/scenarios/index.js